<template>
  <a-modal
    ref="authRole"
    title="选择用户"
    :width="900"
    v-model:visible="visible"
    :confirm-loading="submitLoading"
    @cancel="close"
    @ok="confirm"
    :maskClosable="false"
    :keyboard="false"
    wrap-class-name="select-user-modal"
  >
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="用户名称">
              <a-input
                v-model:value="queryParam.userName"
                placeholder="请输入"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="手机号码">
              <a-input
                v-model:value="queryParam.phonenumber"
                placeholder="请输入"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery" class="search-button">
                <SearchOutlined />搜索
              </a-button>
              <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">
                重置
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :scroll="{ x: 'max-content', y: tableHeight }"
        :pagination="false"
        :bordered="tableBordered"
        class="optimized-table"
      >
        <template #bodyCell="{ column, text, record }">
          <!-- 状态 -->
          <template v-if="column.dataIndex === 'status'">
            <dict-tag :options="statusOptions" :value="record.status" />
          </template>
          <!-- 创建时间 -->
          <template v-else-if="column.dataIndex === 'createTime'">
            {{ parseTime(record.createTime) }}
          </template>
          <!-- 其他字段 -->
          <template v-else>
            {{ text }}
          </template>
        </template>
      </a-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <div class="pagination-left">
        <span class="pagination-info">
          显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第 {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
        </span>
        <a-select
          v-model:value="queryParam.pageSize"
          style="width: 100px; margin-left: 8px"
          @change="(value) => onShowSizeChange(queryParam.pageNum, value)"
          class="no-border-radius-select"
        >
          <a-select-option :value="10">10条/页</a-select-option>
          <a-select-option :value="20">20条/页</a-select-option>
          <a-select-option :value="50">50条/页</a-select-option>
          <a-select-option :value="100">100条/页</a-select-option>
        </a-select>
      </div>
      <div class="pagination-right">
        <a-pagination
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="false"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { SearchOutlined, RedoOutlined } from '@ant-design/icons-vue'
import { $emit } from '../../../../utils/gogocodeTransfer'
import { tableMixin } from '@/store/table-mixin'
import { unallocatedUserList, authUserSelectAll } from '@/api/system/role'

export default {
  name: 'AuthUser',
  mixins: [tableMixin],
  props: {
    roleId: {
      type: String,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {
    SearchOutlined,
    RedoOutlined,
  },
  data() {
    return {
      // 表格数据
      list: [],
      user: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 表格高度
      tableHeight: document.documentElement.scrollHeight - 500 + 'px',
      // 选中用户ID数组
      userIds: [],
      loading: false,
      total: 0,
      // 控件状态
      submitLoading: false,
      visible: false,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        roleId: undefined,
        userName: undefined,
        phonenumber: undefined,
      },
      // 表格列配置
      columns: [
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '用户昵称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '手机',
          dataIndex: 'phonenumber',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
        },
      ],
    }
  },
  methods: {
    // 获取用户列表
    getList() {
      this.loading = true
      unallocatedUserList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    
    // 关闭模态框
    close() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.userIds = []
    },
    
    // 打开模态框（外部调用）
    handleAuthUser() {
      this.queryParam.roleId = this.roleId
      this.visible = true
      this.getList()
    },
    
    // 确认选择
    confirm() {
      const param = {
        roleId: this.queryParam.roleId,
        userIds: this.userIds,
      }
      this.submitLoading = true
      authUserSelectAll(param)
        .then((res) => {
          this.$message.success(res.message)
          this.visible = false
          $emit(this, 'ok')
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    
    // 搜索
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    
    // 重置查询
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        roleId: this.queryParam.roleId,
        userName: undefined,
        phonenumber: undefined,
      }
      this.handleQuery()
    },
    
    // 分页大小变化
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    
    // 分页变化
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    
    // 行选择变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.userIds = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
  },
  emits: ['ok'],
}
</script>

<style scoped>
/* 条件搜索区域 */
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 输入框样式 */
.no-border-radius-input :deep(.ant-input),
.table-page-search-wrapper :deep(.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input:hover),
.table-page-search-wrapper :deep(.ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:hover) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 输入框内部样式 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择器样式 */
.no-border-radius-select :deep(.ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-select :deep(.ant-select-selector:hover),
.table-page-search-wrapper :deep(.ant-select-selector:hover) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-select :deep(.ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 无边框按钮 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

/* 全局按钮圆角 */
.table-page-search-wrapper :deep(.ant-btn),
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页样式 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 分页组件圆角 */
.pagination-wrapper :deep(.ant-btn),
.pagination-wrapper :deep(.ant-pagination-item),
.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button),
.pagination-wrapper :deep(.ant-input-number),
.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 4px !important;
}

/* 分页选中页 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

/* 表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 表格边框 */
:deep(.ant-table),
:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 选中行样式 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td),
:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 4px !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner),
.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 取消按钮样式 - 在 scoped 样式中使用 :deep() 确保穿透 */
:deep(.select-user-modal .ant-modal-footer .ant-btn-default),
:deep(.ant-modal-footer .ant-btn-default) {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
}

:deep(.select-user-modal .ant-modal-footer .ant-btn-default:hover),
:deep(.ant-modal-footer .ant-btn-default:hover) {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
}

:deep(.select-user-modal .ant-modal-footer .ant-btn-default:focus),
:deep(.select-user-modal .ant-modal-footer .ant-btn-default:active),
:deep(.ant-modal-footer .ant-btn-default:focus),
:deep(.ant-modal-footer .ant-btn-default:active) {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
  box-shadow: none !important;
}
</style>

<style>
/* Modal 按钮样式 - 全局样式确保生效 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

/* 取消按钮样式 - 使用最高优先级 */
.select-user-modal .ant-modal-footer .ant-btn-default,
.ant-modal-footer .ant-btn-default {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
}

.select-user-modal .ant-modal-footer .ant-btn-default:hover,
.ant-modal-footer .ant-btn-default:hover {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
}

.select-user-modal .ant-modal-footer .ant-btn-default:focus,
.select-user-modal .ant-modal-footer .ant-btn-default:active,
.ant-modal-footer .ant-btn-default:focus,
.ant-modal-footer .ant-btn-default:active {
  background: #F3F3F3 !important;
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  border-radius: 4px 4px 4px 4px !important;
  color: #101010 !important;
  box-shadow: none !important;
}

/* 确定按钮样式 */
.select-user-modal .ant-modal-footer .ant-btn-primary,
.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.select-user-modal .ant-modal-footer .ant-btn-primary:hover:not(:disabled),
.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.select-user-modal .ant-modal-footer .ant-btn-primary:focus:not(:disabled),
.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.select-user-modal .ant-modal-footer .ant-btn-primary:active:not(:disabled),
.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}
</style>